import Box from '@mui/material/Box';
import { RichText, TextField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { StContentHeadingBox, StContentHeadingSubBox } from './ContentWithHeading.styles';
import UiHeading from '../Heading';

interface IReferencesFields {
  heading?: TextField;
  content?: RichTextField;
  backgroundColor?: TextField;
}
interface IReferencesProps extends ComponentProps {
  fields?: IReferencesFields;
}
const ContentWithHeading: React.FC<IReferencesProps> = (props) => {
  if (!props?.fields) return <></>;
  return (
    <StContentHeadingBox
      className="ui-section-content-with-heading"
      sx={{ backgroundColor: props?.fields?.backgroundColor?.value?.toString() }}
    >
      <StContentHeadingSubBox>
        <Box display="flex" justifyContent="center" alignItems="center">
          <UiHeading size="h2">{props.fields?.heading}</UiHeading>
        </Box>
        <Box sx={{ color: (theme) => theme.palette.common.black }}>
          <RichText field={props.fields?.content} />
        </Box>
      </StContentHeadingSubBox>
    </StContentHeadingBox>
  );
};

export default ContentWithHeading;
